import Slider from "../components/sliders";

document.addEventListener("DOMContentLoaded", (e) => {
	const news_slider = document.querySelectorAll(".news-slider");
	if (news_slider) {
		news_slider.forEach((slider) => {
			const swiper = slider.querySelector(".swiper");
			if (swiper) {
				Slider.initSwiper(swiper, {
					slidesPerView: 1,
					loop: true,
					pagination: {
						el: ".news-slider-pagination",
						type: "bullets",
						clickable: true,
					},
					navigation: {
						nextEl: slider.querySelector(".news-slider-next-slide-sm"),
					},
					breakpoints: {
						768: {
							navigation: {
								nextEl: ".news-slider-next-slide",
							},
						},
					},
				});
			}
		});
	}
});
